import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';

const CmsElementImage = (props) => {
  const { index, editMode } = props;

  // dnd-kit Sortable Hook
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: index,
    disabled: !editMode
  });

  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
  } = useAbstractCmsElement(props);

  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : 1,
    cursor: editMode ? 'grab' : 'default',
  };

  const showSettings = (e) => {
    props.showElementSettings(e, index);
  };

  const getImgComponent = () => {
    let styleClass = `drop-shadow-${getParamValue('shadow')} rounded-corners-${getParamValue('roundCorners')} `;
    let imageUrl = getParamValue('imageUrl');

    if (!imageUrl) {
      return (
        <div className="p-t-15 p-b-15 text-center">
          <i className="fa fa-image fa-4x" />
        </div>
      );
    }

    return (
      <img
        src={imageUrl}
        className={`ms-img img-responsive ${styleClass}`}
        alt={getParamValue('imageFileTitle')}
      />
    );
  };

  const parallaxData = getParallaxData();

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-img relative ${shown ? 'elem-shown ' : 'elem-hidden '} ${cssClasses}`}
      onClick={showSettings}
      style={{ ...getBackgroundStyle() }}
      {...attributes}
      {...listeners}
    >
      {elementStyleTag}
      {getImgComponent()}
      {getAppendHtml()}
    </div>
  );

  return (
    <div ref={setNodeRef} style={dndStyle}>
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>
    </div>
  );
};

export default CmsElementImage;
